import React, { Component } from 'react'
import {isAuthenticated, signout} from '../auth';
import {remove} from './apiUser';
import {Redirect} from 'react-router-dom';

export default class DeleteUser extends Component {

    state = {
        redirect: false
    }

    deleteAccount = () => {
        const token = isAuthenticated().token;
        const userId = this.props.userId;
        remove(userId, token)
        .then(data => {
            if(data.error){
                console.log(data.error);
            }else{
                // delete user //
                signout(() => console.log("user is deleted."));
                this.setState({redirect: true});
            }
        })

    }

    deleteConfirmed = () => {
        let answer = window.confirm("Are you sure you want to delete your account?");
        if(answer){
            this.deleteAccount();
        }
    }

    render() {
        if(this.state.redirect){
            return <Redirect to="/" />
        }
        return (
            <>
                <button onClick={this.deleteConfirmed} className="btn btn-raised btn-danger btn-sm">Delete Profile</button>
            </>
        )
    }
}
